export default __webpack_public_path__ + "static/media/element_81.8c585e41.jpg";